import { render, staticRenderFns } from "./LayoutPublic.vue?vue&type=template&id=74b899d2&lang=pug&"
import script from "./LayoutPublic.vue?vue&type=script&lang=js&"
export * from "./LayoutPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
